<template>
    <div style="background:red;color:white;padding:5px;width:100%;">
      Failed to {{ message }}! Check your connection, then <a @click="$emit('try')" style="color: yellow;">Try Again</a>
    </div>
</template>

<script>
export default {
  props: ['message']
}
</script>
